import React, { useEffect, useState } from "react";
import "./App.css";
import { useTranslation } from "react-i18next";

function shuffleArray(array) {
  const shuffled = [...array];
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  return shuffled;
}

const LoadingMessage = ({ showSpinner = true }) => {
  const { t } = useTranslation();
  const [messages, setMessages] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [fade, setFade] = useState(true);

  const facts = [
    t("facts1"),
    t("facts2"),
    t("facts3"),
    t("facts4"),
    t("facts5"),
    t("facts6"),
    t("facts7"),
    t("facts8"),
    t("facts9"),
    t("facts10"),
  ];

  useEffect(() => {
    const randomized = shuffleArray(facts);
    const alternatingMessages = randomized.flatMap((msg) => [t("caricamento"), msg]);
    setMessages(alternatingMessages);
  }, [t]);

  useEffect(() => {
    if (messages.length === 0) return;

    const currentMessage = messages[currentIndex];
    const delay = currentMessage === t("caricamento") ? 1000 : 4000;

    const timeout = setTimeout(() => {
      setFade(false);
      setTimeout(() => {
        setCurrentIndex((prev) => (prev + 1) % messages.length);
        setFade(true);
      }, 300);
    }, delay);

    return () => clearTimeout(timeout);
  }, [currentIndex, messages, t]);

  return (
    <div className="loading-container">
      {showSpinner && <div className="spinner" />}
      <p className={`loading-text ${fade ? "fade-in" : "fade-out"}`}>
        {messages[currentIndex]}
      </p>
    </div>
  );
};

export default LoadingMessage;
